// extracted by mini-css-extract-plugin
export default {"totals":"cart-totals_totals__RGVGU","shipping-country":"cart-totals_shipping-country__dDVNu","select":"cart-totals_select__x0O95"};